module.exports = __webpack_public_path__ + "static/media/favouriteselected.7c1f5ed0.svg";